/**
 * Query keys for the catalogue (`../core/keys.ts` is the convention).
 *
 * The list key carries the query as the WIRE record (`toExerciseListParams`
 * without the cursor), not the caller's object: an omitted filter and an
 * empty search box are then the same key, and the key and the request can
 * never disagree about what was asked. The cursor is not part of it — it is
 * the page parameter of one infinite query, not a different query.
 */
export const DEFAULT_CATALOG_LOCALE = "en";
export const catalogKeys = {
    all: ["catalog"],
    list: (params) => ["catalog", "list", params],
    listAll: ["catalog", "list"],
    detail: (id, locale = DEFAULT_CATALOG_LOCALE) => ["catalog", "detail", id, locale],
    filters: (locale = DEFAULT_CATALOG_LOCALE) => ["catalog", "filters", locale],
};
//# sourceMappingURL=keys.js.map